<template lang="pug">
.file-card
  .f-card-container
    vm-tooltip.fix-button(:text="$t('strings.options')" delay=".5s")
      vm-dropdown(vm-custom-content vm-trigger-click)
        vm-button(type="border" icon="more-vertical" color="#afbbc6")
        vm-dropdown-menu
          vm-dropdown-item.d-flex.justify-content-between(@click="deleteImage(data)" v-if="showDelete && !$auth.check('Customer')")
            vm-icon(icon="trash-2-outline")
            slot &nbsp;{{ $t('strings.delete') }}
          vm-dropdown-item.d-flex.justify-content-between(@click="downloadImage(data)")
            vm-icon(icon="download-outline")
            slot &nbsp;{{ $t('strings.download') }}
          vm-dropdown-item.d-flex.justify-content-between(@click="$emit('view', data)" v-if="showSee")
            vm-icon(icon="eye-outline")
            slot &nbsp;{{ $t('strings.view') }}
          vm-dropdown-item.d-flex.justify-content-between(@click="downloadFile(backupUrl)" v-if="backupUrl != null && !$auth.check('Customer')")
            vm-icon(icon="copy-outline")
            slot &nbsp;{{ $t('strings.download_backup') }}
    .body-card(v-if="!!thumbnail" :style="!!thumbnail && `background: url(${encodeURI(thumbnail)}) no-repeat center / cover`" @click="$emit('view', data)")
    .icon-card(v-else @click="$emit('view', data)")
      img.icon(:src='checkMimeType')
    .title-card(@click="$emit('view', data)")
      .format-icon
        vm-icon(icon="image-outline" v-if="!!thumbnail" size="1.2rem" color="rgb(237, 28, 36)")
        vm-icon(icon="file-text-outline" v-else size="1.2rem" color="rgb(237, 28, 36)")
      .title {{ data.filename }}
    .comments(@click="$emit('view', data)" v-if="data.comments")
      span {{ data.comments }}
    .subtitles(@click="$emit('view', data)")
      span {{ fromNowFormat(data.date) }}
      br
      span {{ data.shipment ? data.shipment.name : '' }}
</template>

<script>
import moment from 'moment'
export default {
  name: 'FileCard',
  props: {
    thumbnail: {
      type: String
    },
    data: {
      type: Object
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    showSee: {
      type: Boolean,
      default: true
    },
    backupUrl: {
      type: String
    }
  },
  data: () => ({
    counter: 0
  }),
  computed: {
    checkMimeType () {
      if (this.data.mime_type.includes('text')) {
        return require('@/assets/icons/txt.svg')
      } else if (this.data.mime_type.includes('pdf')) {
        return require('@/assets/icons/pdf.svg')
      } else if (this.data.mime_type.includes('xls') || this.data.mime_type.includes('spread')) {
        return require('@/assets/icons/excel.svg')
      } else if (this.data.mime_type.includes('word')) {
        return require('@/assets/icons/word.svg')
      } else if (this.data.mime_type.includes('image')) {
        return require('@/assets/icons/image.svg')
      } else if (this.data.mime_type.includes('video')) {
        return require('@/assets/icons/video.svg')
      } else if (this.data.mime_type.includes('zip')) {
        return require('@/assets/icons/zip.svg')
      } else if (this.data.mime_type.includes('gif')) {
        return require('@/assets/icons/gif.svg')
      } else {
        return require('@/assets/icons/file.svg')
      }
    }
  },
  methods: {
    fromNowFormat (date) {
      const moment = require('moment-timezone');
      const momentDate = moment.tz(date, "DD-MMM-YYYY HH:mm:ss", "America/Mexico_City");
      return momentDate.fromNow()
    },
    deleteImage (imagen) {
      this.$emit('attachment', imagen)
    },
    downloadImage (imagen) {
      window.open(imagen.file_url, '_blank')
    },
    downloadFile (fileUrl) {
      window.open(fileUrl, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.file-card {
  box-sizing: content-box;
  border: 3px solid transparent;
  transition: 0.05s all ease-in-out;
  border-radius: 10px;
  cursor: pointer;
  padding: 5px;
  min-width: 190px;
  margin: 20px;
  .f-card-container {
    min-width: 130px;
    height: 250px;
    border-radius: 10px;
    background: white;
    border: 1px solid rgb(226, 226, 226);
    -webkit-box-shadow: 0px 3px 0px 0px rgba(0,0,0,0.09);
    -moz-box-shadow: 0px 3px 0px 0px rgba(0,0,0,0.09);
    box-shadow: 0px 3px 0px 0px rgba(0,0,0,0.09);
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    user-select: none;
    transition: 0.3s all ease-in-out;
    position: relative;
  }
  &:hover {
    border: 3px solid rgba(var(--primary), 1);
  }
}
.body-card {
  height: 100%;
  width: 100%;
  background: white;
}
.icon-card {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon {
  width: 80px;
  height: auto;
}
.title-card {
  height: 60px;
  width: 100%;
  border-top: 1px solid rgb(226, 226, 226);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title {
  width: 100%;
  font-size: 13px;
}
.format-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px 0 15px;
}
button {
  border: 0 !important;
  cursor: pointer;
}
.fix-button {
  position: absolute;
  right: 0;
  top: 0;
}
.subtitles {
  display: inline-block;
  font-size: 11px;
  align-items: center;
  justify-content: space-between;
  padding: 0px 18px 10px 18px;
}
.comments {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 13px;
  justify-content: space-between;
  padding: 0px 18px 10px 18px;
}
</style>
